export default {
  signature: {
    qa: 'Kontrola jakości',
    lab: 'Laboratorium',
  },
  errors: {
    downloadPdfFailed: 'Nie udało się pobrać raportu jakości dla {report}. Jeśli błąd będzie się powtarzał, prosimy o kontakt z pomocą techniczną Qmulus',
  },
};
